import React from "react";

const LoginHeader = () => {
  return (
    <div className="mb-8 text-center">
      <div className="mb-6">
        <div className="inline-flex justify-center items-center w-16 h-16 bg-gradient-to-r from-red-500 to-red-500 rounded-2xl shadow-lg transition-transform duration-300 transform hover:scale-105">
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      </div>

      <h1 className="mb-2 text-3xl font-bold text-transparent text-gray-700  bg-clip-text bg-gray-800">
        Welcome Back
      </h1>
      <p className="text-sm text-gray-700">Sign in to your admin dashboard</p>

      <div className="flex justify-center items-center mt-6">
        <div className="flex-1 h-px bg-gradient-to-r from-transparent to-transparent via-white/30"></div>
        <div className="mx-4 w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
        <div className="flex-1 h-px bg-gradient-to-r from-transparent to-transparent via-white/30"></div>
      </div>
    </div>
  );
};

export default LoginHeader;
